/**
 * UserAvatar — renders a user's profile photo with optional privacy blur.
 *
 * Props:
 *   src              – photo URL (absolute or relative /api/uploads/...)
 *   alt              – img alt text
 *   className        – Tailwind classes (size, shape, border, etc.)
 *   privacyMode      – "normal" | "pixelated"  (default: "normal")
 *   fallback         – JSX element to render when src is absent (default: null)
 */

const API_BASE = typeof window !== "undefined" ? window.location.origin : (process.env.REACT_APP_BACKEND_URL || "");

export function UserAvatar({
  src,
  alt = "",
  className = "",
  privacyMode = "normal",
  fallback = null,
}) {
  const isBlurred = privacyMode === "pixelated";
  const resolvedSrc = src
    ? src.startsWith("http") ? src : `${API_BASE}${src}`
    : null;

  if (!resolvedSrc) return fallback;

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={className}
      data-privacy={privacyMode}
      style={isBlurred ? { filter: "blur(10px) saturate(0.35)" } : undefined}
    />
  );
}
